import { memo, useMemo } from 'react';
import { countriesWithPhone } from './constants';
import StyledTextField from '@shared/components/StyledTextField';
import FormSection from '@shared/components/FormSection';
import GenericDropdown from '@shared/components/GenericDropdown';

const NoTravelContact = ({ formik }) => {
  const selectedCodePhone = useMemo(() => {
    const codeValue = formik.values.noTraveler?.codePhone;
    if (!codeValue) return null;
    const country = countriesWithPhone.find(c => c.value === codeValue);
    if (!country) return null;
    return {
      id: country.value,
      value: country.value,
      fragments: [{ text: country.label, bold: false }],
    };
  }, [formik.values.noTraveler, countriesWithPhone]);

  return (
    <FormSection
      title={'Contacto de emergencia'}
      id={'noTraveler'}
      customLayout={{
        md: {
          1: 3,
          2: 3,
          3: 1.9,
          4: 1.6,
          5: 2.5,
          6: 6,
        },
      }}
    >
      <StyledTextField
        formik={formik}
        name={`noTraveler.name`}
        label="Nombre (como figura en el documento)"
      />
      <StyledTextField
        formik={formik}
        name={`noTraveler.lastname`}
        label="Apellido (como figura en el documento)"
      />
      <GenericDropdown
        id="noTraveler.codePhone"
        items={countriesWithPhone.map((country, idx) => ({
          id: `noViajacountryPhone-${country.value}-${idx}`,
          value: country.value,
          fragments: [{ text: country.label, bold: false }],
        }))}
        selectedItem={selectedCodePhone}
        onSelect={item =>
          formik.setFieldValue(`noTraveler.codePhone`, item.value)
        }
        buttonLabel="Código"
        hasError={
          formik.touched.noTraveler?.codePhone &&
          Boolean(formik.errors.noTraveler?.codePhone)
        }
        helperText={formik.errors.noTraveler?.codePhone}
      />
      <StyledTextField
        label="Cod. de área"
        name="noTraveler.caracteristicPhone"
        formik={formik}
      />
      <StyledTextField
        formik={formik}
        name={`noTraveler.phone`}
        label="Celular (sin el 15)"
      />
      <StyledTextField
        formik={formik}
        name={`noTraveler.email`}
        label="E-mail"
      />
    </FormSection>
  );
};
export default memo(NoTravelContact);
